module.exports = new __parcel__URL__("hp_icon.fc3570b9.png").toString();